"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var r = require("revalidate");
var password_1 = require("../common/password");
// import { actionCreators as sagaActionCreators } from '../../web/src/redux/sagas'
var createValidator = r.createValidator;
var composeValidators = r.composeValidators;
var combineValidators = r.combineValidators;
var isRequired = r.isRequired;
var matchesPattern = r.matchesPattern;
var matchesField = r.matchesField;
var districtSchoolValidator = createValidator(function (message) { return function (value, allValues) {
    if (value == null || value === '') {
        return message;
    }
    var current_school_id = allValues['current_school_id'];
    if (!current_school_id) {
        return message;
    }
}; }, function (field) { return field + " is required"; });
exports.registerSchoolValidator = combineValidators({
    district: composeValidators(isRequired({ message: "districtRequired" }))("district"),
    school: composeValidators(districtSchoolValidator({ message: "schoolEnforceSelection" }))("school"),
    email: composeValidators(isRequired({ message: "emailRequired" }), matchesPattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)({ message: "emailInvalid" }))("email")
});
exports.registerStudentValidator = combineValidators({
    firstName: isRequired({ message: "firstNameRequired" }),
    birthDate: composeValidators(matchesPattern(/^(\d{4}-\d\d-\d\d)$/)({ message: "birthDateInvalid" }))("birthDate")
});
exports.registerPasswordValidator = combineValidators({
    password: password_1.passwordValidator,
    passwordConfirm: matchesField("password", "password")({
        message: "doesNotMatch"
    }),
    acceptTos: isRequired({ message: "isRequired" }),
    captchaResponse: isRequired({ message: "isRequired" })
});
//# sourceMappingURL=register.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/register/register.js
// module id = 465
// module chunks = 22